module.exports = {
    CarsData: () => {
      return [
        {
          "id": "mg_zs_hybrid_2025",
          "name" : "MG ZS HYBRID+",
          "fullname" : "MG ZS HYBRID+",
          "category" : "Vehículo híbrido",
          // "card": require('../assets/cars/nueva-santafe-cr-intro.webp'),
          // "background": '#9b4826',
          "url": "./pc/mg_zs_hybrid_2025/v4/index.html",
          "interactable" : true,
          "active" : true,
        },
      ]
    }
  }